module.exports = __webpack_public_path__ + "img/card-avatar-bronze.1bff98f0.png";